function generateStyles(properties) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  if (!properties) {
    return "";
  }
  let background = (_a = properties.background_color) == null ? void 0 : _a.hex;
  if (properties.background_gradient_style === "linear") {
    background = `linear-gradient(${(_c = (_b = properties.background_gradient_color) == null ? void 0 : _b.color1) == null ? void 0 : _c.hex}, ${(_e = (_d = properties.background_gradient_color) == null ? void 0 : _d.color2) == null ? void 0 : _e.hex})`;
  } else if (properties.background_gradient_style === "radial") {
    background = `radial-gradient(${(_g = (_f = properties.background_gradient_color) == null ? void 0 : _f.color1) == null ? void 0 : _g.hex}, ${(_i = (_h = properties.background_gradient_color) == null ? void 0 : _h.color2) == null ? void 0 : _i.hex})`;
  }
  return background || "";
}
export {
  generateStyles
};
